module.exports = __webpack_public_path__ + "static/media/1. Alambre2, Mixta sobre madera, 120 x 90 cm, 2019 copy.ec7577d8.png";